var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "right" },
      [
        _c(
          "v-btn",
          {
            staticClass: "mr-0",
            attrs: { color: "" },
            on: {
              click: function($event) {
                return _vm.getDateTotal()
              }
            }
          },
          [_vm._v("reveal "), _c("b", [_vm._v(_vm._s(_vm.currentMonthYear))])]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "left" },
      [
        _c("Fullcalendar", {
          attrs: {
            plugins: _vm.calendarPlugins,
            header: {
              left: "prev",
              center: " title ",
              right: "next"
            },
            selectable: true,
            events: _vm.fcEvents,
            showNonCurrentDates: false,
            eventColor: "#339900",
            displayEventTime: false,
            theme: true
          },
          on: {
            eventClick: _vm.handleClick,
            datesRender: _vm.handleMonthChange
          }
        }),
        _vm._v(" "),
        _c("modals-container")
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-eb7a4788", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb7a4788","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Agenda.vue
// module id = null
// module chunks = 